module.exports = __webpack_public_path__ + "media/images/entities_logo/logo_cemaden-fbb1b7cd2f7ce5d40d5ad6b88dd8844e.png";